import { mutationTree, actionTree } from 'typed-vuex'
import { AxiosResponse } from 'axios'
import { setState } from '~/lib/utils/store'

export const state = () => ({
  token: null,
  integration: null,
  stripePaymentIntent: {}
})

export const mutations = mutationTree(state, {
  setState
})

export const actions = actionTree(
  { state, mutations },
  {
    getToken({ state, commit }) {
      if (state.token) {
        if (typeof state.token === 'string') { return Promise.resolve(state.token) }
        return state.token.then((res: AxiosResponse) => res.data.data.token)
      }

      const promise = this.$api.payment.retrieveBraintreeToken()
      commit('setState', { stateName: 'token', data: promise })

      return promise.then((res) => {
        commit('setState', { stateName: 'token', data: res.data.data.token })
        return res.data.data.token
      })
    }
  }
)
